export default __webpack_public_path__ + "static/media/722.e00c1dd6.png";